// extracted by mini-css-extract-plugin
export var deleteModal = "_qf-0";